import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IUser,
    LoginPayload,
    ODataResponse,
} from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class CurrentUserService extends ODataService<IUser | null, number> {
    protected _endpoint = '/odata/Users';

    constructor(
        protected _http: HttpClient,
    ) {
        super(_http, MapperService.userMap);
    }

    public get = () => {
        return this._http.get<any>(
            `${this._endpoint}/UiPath.Server.Configuration.OData.GetCurrentUser`,
        ).pipe(
            map(data => data && this._toDto(data)),
        ) as unknown as Observable<ODataResponse<IUser | null>>;
    }

    public login(payload: LoginPayload) {
        return this._http.post('/account/login', JSON.stringify(payload));
    }

    public logout() {
        return this._http.get('/account/logout');
    }

    public ensureCorrectIdentity() {
        return this._http.get('/antiforgery/token', { responseType: 'text' });
    }
}
